export const MessageChannel = {
    SMS: 'sms',
    EMAIL: 'email',
    TEMPLATE: 'template',
};

export const MessageStatus = {
    SENT: 'sent',
    DRAFT: 'draft',
    FAILED: 'failed',
    QUEUED: 'queued',
    SENDING: 'sending',
    DELIVERED: 'delivered',
    PREPARING: 'preparing',
} as const;
